export default function Security() {
  const protocols = [
    { name: 'OpenVPN', icon: 'ri-shield-check-line' },
    { name: 'WireGuard', icon: 'ri-shield-star-line' },
    { name: 'IKEv2', icon: 'ri-shield-keyhole-line' }
  ];

  const benefits = [
    'Bank-level encryption protects all your online activities',
    'DNS leak protection ensures your real IP stays hidden',
    'Automatic kill switch prevents data exposure',
    'Split tunneling for flexible security control',
    'No bandwidth throttling or speed limits',
    'Protection against DDoS attacks and malware'
  ];

  return (
    <section id="security" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-5 gap-12 items-center">
          <div className="md:col-span-2">
            <div className="bg-gradient-to-br from-gray-900 to-blue-900 rounded-3xl p-8 relative overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-br from-blue-600/20 to-purple-600/20"></div>
              
              <div className="relative z-10">
                <div className="flex justify-center mb-8">
                  <div className="w-32 h-32 bg-blue-500/20 rounded-full flex items-center justify-center animate-pulse">
                    <i className="ri-shield-check-line text-blue-400 text-6xl"></i>
                  </div>
                </div>

                <h3 className="text-white text-2xl font-bold text-center mb-8">
                  Security Protocols
                </h3>

                <div className="space-y-4">
                  {protocols.map((protocol, index) => (
                    <div
                      key={index}
                      className="bg-white/10 backdrop-blur-sm rounded-xl p-4 flex items-center gap-4"
                    >
                      <div className="w-10 h-10 bg-blue-500 rounded-lg flex items-center justify-center">
                        <i className={`${protocol.icon} text-white text-xl`}></i>
                      </div>
                      <span className="text-white font-semibold">{protocol.name}</span>
                      <i className="ri-check-line text-green-400 text-xl ml-auto"></i>
                    </div>
                  ))}
                </div>

                <div className="mt-8 grid grid-cols-2 gap-4">
                  <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 text-center">
                    <p className="text-blue-400 text-3xl font-bold">256-bit</p>
                    <p className="text-white/80 text-sm mt-1">Encryption</p>
                  </div>
                  <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 text-center">
                    <p className="text-purple-400 text-3xl font-bold">100%</p>
                    <p className="text-white/80 text-sm mt-1">Secure</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="md:col-span-3">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Uncompromising Security & Privacy
            </h2>
            
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              AGIT VPN uses <span className="text-purple-600 font-semibold">military-grade AES-256 encryption</span> to secure your internet connection. This is the same encryption standard trusted by governments and security experts worldwide.
            </p>

            <p className="text-gray-600 mb-8 leading-relaxed">
              Our strict <span className="text-purple-600 font-semibold">no-logs policy</span> means we never track, collect, or share your browsing data. Your online activities remain completely private and anonymous.
            </p>

            <div className="space-y-4">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-green-600 text-sm"></i>
                  </div>
                  <p className="text-gray-700">{benefit}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
